module.exports = __webpack_public_path__ + "static/media/EP02@s.95e10d19.jpg";